import "spark-bootstrap";
import "./components/funnel/funnel.js";
import "./components/informationMap.js";
import "./components/metamaskButton.js";
import "./components/maintenance/maintenance.js";
import spark from "spark";
var app = new Vue({
    mixins: [spark],
});
